import {
  aBigIntDataPoint,
  mockRuleSignalCountOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const ruleSignalCountResponse = {
  __typename: 'Query' as const,
  signalCounts: [aBigIntDataPoint()],
};

export const handlers = [
  mockRuleSignalCountOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: ruleSignalCountResponse,
      });
    }
  ),
];
